import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import { Button, Badge } from "react-bootstrap";
import { Tooltip, OverlayTrigger, Dropdown, DropdownButton, ButtonGroup } from "react-bootstrap";
import swal from "sweetalert2";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import { components } from 'react-select';
import Select from 'react-select';
import DatePicker, { DateObject } from "react-multi-date-picker";
import ViewPurchaseHistory from '../../../modal/Purchase_Management/Purchase_History/View' 
import PurchaseHistoryList from '../../../modal/Purchase_Management/Purchase_History/View' 
const Purchase = () => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [open, setOpen] = useState(false); // Modal visibility state     
    const [modalType, setModalType] = useState(""); 

    const tableRef = useRef(null);

    const filter_type = [
        { value: 0, label: 'Date' },
        { value: 1, label: 'Vendor' },
        { value: 2, label: 'Raw Material' }
    ]

    const [vendorOptions, setVendorOptions] = useState([]);
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [vendorPurchases, setVendorPurchases] = useState([]);
    const [selectedVendorInfo, setSelectedVendorInfo] = useState(null);
    const [rawmaterialOptions, setRawMaterialOptions] = useState([]);
    const [date_fil_selt_value, setDateFilSeltValue] = useState("all");
    const [today_fil_value, setTodayFilValue] = useState(new Date());
    const [week_stdt_fil_value, setWeekSTDTFilValue] = useState(new Date());
    const [week_eddt_fil_value, setWeekEDDTFilValue] = useState(new Date());
    const [month_fil_value, setMonthFilValue] = useState(new Date());
    const [custom_stdt_fil_value, setCustomSTDTFilValue] = useState(new Date());
    const [custom_eddt_fil_value, setCustomEDDTFilValue] = useState(new Date());
    const [modalData, setModalData] = useState(null); 
    const [selectedRawMaterial, setSelectedRawMaterial] = useState(null);
    const [rawMaterialPurchases, setRawMaterialPurchases] = useState([]);
    const [selectedRawMaterialInfo, setSelectedRawMaterialInfo] = useState(null);

    const [selectedFilter, setSelectedFilter] = useState(filter_type[0]);
    useEffect(() => {
        // Fetch vendors from your API
        fetch(`${baseURL}/managevendor/vendors/active`)
        .then(res => res.json())
        .then(data => {
            if (data.vendors) {
            // Map vendors to { value, label }
            const options = data.vendors.map(vendor => ({
                value: vendor.sno,
                label: vendor.vendor_businessname,
            }));
            setVendorOptions(options);
            }
        })
        .catch(err => {
            console.error('Error fetching vendors:', err);
        });
    }, []); 

    useEffect(() => {
        const fetchRawMaterials = async () => {
            try {
                const response = await fetch(`${baseURL}/raw-materials/list/active`);
                const data = await response.json();

                if (data?.data && Array.isArray(data.data)) {
                    const options = data.data.map((raw) => ({
                        value: raw.sno,
                        label: raw.rawmaterial_name,
                    }));
                    setRawMaterialOptions(options);
                } else {
                    console.warn("Unexpected raw materials response structure:", data);
                    setRawMaterialOptions([]);
                }
            } catch (error) {
                console.error("Error fetching Raw Materials:", error);
                setRawMaterialOptions([]);
            }
        };

        fetchRawMaterials();
    }, [baseURL]);

    const handleRawMaterialChange = (rawMaterial) => {
            setSelectedRawMaterial(rawMaterial);

            fetch(`${baseURL}/vendor/purchases/?raw_material_id=${rawMaterial.value}`)
                .then(res => res.json())
                .then(data => {
                    if (data?.data && Array.isArray(data.data)) {
                        setRawMaterialPurchases(data.data);
                        setSelectedRawMaterialInfo(data.raw_material || rawMaterial); // fallback if API doesn't return extra info
                    } else {
                        setRawMaterialPurchases([]);
                        setSelectedRawMaterialInfo(null);
                    }
                })
                .catch(err => {
                    console.error('Error fetching raw material purchases:', err);
                    setRawMaterialPurchases([]);
                    setSelectedRawMaterialInfo(null);
                });
    };

    const handleModalToggle_View = (purchase) => {
        setModalType("ViewPurchaseHistory");
        setModalData(purchase);
        setOpen(true);
    };

    const Group = (props) => (
        <div>
            <components.Group {...props} />
        </div>
    );

    const customStyles = {
        groupHeading: (provided) => ({
            ...provided,
            fontSize: '14px',  // Increase the font size for group labels
            fontWeight: 'bold',  // Optional: make the label bold
            color: '#333',  // Optional: change the text color
        }),
    };
 
    const date_fil_options = [
        { value: "all", label: "All" },
        { value: "today", label: "Today" },
        { value: "week", label: "This Week" },
        { value: "month", label: "This Month" },
        { value: "custom", label: "Custom Date" }
    ];
    const [purchases, setPurchases] = React.useState([]);

  
    const handleVendorChange = (vendor) => {
        setSelectedVendor(vendor);

        fetch(`${baseURL}/vendor/purchases/?vendor_id=${vendor.value}`)
            .then(res => res.json())
            .then(data => {
                if (data.data) {
                    setVendorPurchases(data.data);
                    setSelectedVendorInfo(data.vendor);
                } else {
                    setVendorPurchases([]);
                    setSelectedVendorInfo(null);
                }
            })
            .catch(err => {
                console.error('Error fetching vendor purchases:', err);
                setVendorPurchases([]);
                setSelectedVendorInfo(null);
            });
    };

    const filteredPurchases = React.useMemo(() => {
    if (!purchases || purchases.length === 0) return [];

    const today = new Date();
    const startOfDay = new Date(today.setHours(0, 0, 0, 0));

    switch (date_fil_selt_value) {
        case "today":
        return purchases.filter(p => {
            const purchaseDate = new Date(p.purchase_date);
            return (
            purchaseDate >= startOfDay &&
            purchaseDate < new Date(startOfDay.getTime() + 24 * 60 * 60 * 1000)
            );
        });

        case "week":
        return purchases.filter(p => {
            const purchaseDate = new Date(p.purchase_date);
            return (
            purchaseDate >= new Date(week_stdt_fil_value.setHours(0, 0, 0, 0)) &&
            purchaseDate <= new Date(week_eddt_fil_value.setHours(23, 59, 59, 999))
            );
        });

        case "month":
        return purchases.filter(p => {
            const purchaseDate = new Date(p.purchase_date);
            const selectedMonth = month_fil_value.getMonth();
            const selectedYear = month_fil_value.getFullYear();
            return (
            purchaseDate.getMonth() === selectedMonth &&
            purchaseDate.getFullYear() === selectedYear
            );
        });

        case "custom":
        return purchases.filter(p => {
            const purchaseDate = new Date(p.purchase_date);
            return (
            purchaseDate >= new Date(custom_stdt_fil_value.setHours(0, 0, 0, 0)) &&
            purchaseDate <= new Date(custom_eddt_fil_value.setHours(23, 59, 59, 999))
            );
        });

        case "all":
        default:
        return purchases;
    }
    }, [
    purchases,
    date_fil_selt_value,
    today_fil_value,
    week_stdt_fil_value,
    week_eddt_fil_value,
    month_fil_value,
    custom_stdt_fil_value,
    custom_eddt_fil_value
    ]);

    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);

    const [page, setPage] = useState(1); //pagination
    const [totalPages, setTotalPages] = useState(1); //pagination
    const [searchTerm, setSearchTerm] = useState(''); //pagination
    const [perPage, setPerPage] = useState(25); //pagination
    const fetchPurchases = () => {
        if (selectedFilter.value === 1 && selectedVendor) {
            // Fetch purchases by vendor
            fetch(`${baseURL}/vendor/purchases/?vendor_id=${selectedVendor.value}`)
            .then(res => res.json())
            .then(data => {
                if (data.data) {
                setVendorPurchases(data.data);
                setSelectedVendorInfo(data.vendor);
                } else {
                setVendorPurchases([]);
                setSelectedVendorInfo(null);
                }
            })
            .catch(err => {
                console.error('Error fetching vendor purchases:', err);
                setVendorPurchases([]);
                setSelectedVendorInfo(null);
            });
        } else if (selectedFilter.value === 0) {
            // Fetch purchases with date filters applied
            // Construct query params based on date filter values

            let url = `${baseURL}/purchases?branch_id=${branch_id}&per_page=${perPage}&page=${page}`;

            switch (date_fil_selt_value) {
            case "today":
                url += `start_date=${formatDateISO(today_fil_value)}&end_date=${formatDateISO(today_fil_value)}`;
                break;
            case "week":
                url += `start_date=${formatDateISO(week_stdt_fil_value)}&end_date=${formatDateISO(week_eddt_fil_value)}`;
                break;
            case "month":
                // Example: start_date and end_date of selected month
                const startMonth = new Date(month_fil_value.getFullYear(), month_fil_value.getMonth(), 1);
                const endMonth = new Date(month_fil_value.getFullYear(), month_fil_value.getMonth() + 1, 0);
                url += `start_date=${formatDateISO(startMonth)}&end_date=${formatDateISO(endMonth)}`;
                break;
            case "custom":
                url += `start_date=${formatDateISO(custom_stdt_fil_value)}&end_date=${formatDateISO(custom_eddt_fil_value)}`;
                break;
            case "all":
            default:
                // No date filters
                break;
            }

            fetch(url)
            .then(res => res.json())
            .then(data => {
                if (data.data) {
                setPurchases(data.data);
                // setTotalPages(data.data.pagination.total)
                } else {
                setPurchases([]);
                }
            })
            .catch(err => {
                console.error('Error fetching purchases:', err);
                setPurchases([]);
            });
        }
    };
    
    const formatDateISO = (date) => {
    const d = new Date(date);
    return d.toISOString().split('T')[0];
    };

    useEffect(() => {
        if (selectedFilter.value === 0) {
            fetchPurchases();
        }
    }, [selectedFilter, date_fil_selt_value, today_fil_value, week_stdt_fil_value, week_eddt_fil_value, month_fil_value, custom_stdt_fil_value, custom_eddt_fil_value, perPage, page, searchTerm]);

    useEffect(() => {
    if (selectedFilter.value === 1 && selectedVendor) {
        fetchPurchases();
    }
    }, [selectedFilter, selectedVendor]);

    const formatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };


    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0 flex-wrap">
                <div className='mb-2'>
                    <div className="mb-0 px-0">
                        <h4 style={{ color: '#025d3a' }}>Purchase History</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Purchase History
                        </li>
                    </ol>
                </div>  
                {modalType === "ViewPurchaseHistory" && (
                    <PurchaseHistoryList
                        show={open}
                        onClose={() => setOpen(false)}
                        rawMaterials={modalData?.raw_material || []}
                        purchase={modalData} // 👈 pass full purchase object
                    />
                )}


            </div>

            <div className='row mb-4'>
                <div className="col-lg-3 mb-4">
                    <label className="text-black font-w500 fs-7">Filter Type<span className="required">*</span></label>
                    <Select
                        options={filter_type}
                        components={{ Group }}
                        styles={customStyles}
                        placeholder='Select Type'
                        defaultValue={filter_type[0]}
                        onChange={(option) => setSelectedFilter(option)}
                    />
                </div>
                {selectedFilter && selectedFilter.value === 1 && (
                    <div className="col-lg-3 mb-4">
                        <label className="text-black font-w500 fs-7">Vendor<span className="required">*</span></label>
                        <Select
                            options={vendorOptions}
                            components={{ Group }}
                            styles={customStyles}
                            placeholder='Select Type'
                            value={selectedVendor}
                            onChange={(option) => handleVendorChange(option)}
                        />
                    </div>
                )}
                {selectedFilter && selectedFilter.value === 2 && (
                    <div className="col-lg-3 mb-4">
                        <label className="text-black font-w500 fs-7">Raw Material<span className="required">*</span></label>
                        <Select
                            options={rawmaterialOptions}
                            components={{ Group }}
                            styles={customStyles}
                            placeholder='Select Type'
                            value={selectedRawMaterial}
                            onChange={handleRawMaterialChange}
                        />
                    </div>
                )}
             
                {selectedFilter && selectedFilter.value === 0 && (
                <div className="col-lg-3 mb-2">
                    <label className="text-black font-w500 fs-7">Date</label>
                    <Select
                    value={date_fil_options.find(option => option.value === date_fil_selt_value)}
                    onChange={(selectedOption) => setDateFilSeltValue(selectedOption.value)}
                    options={date_fil_options}
                    />
                </div>
                )}
                {date_fil_selt_value === "all" && selectedFilter && selectedFilter.value === 0 && <></>}

                {date_fil_selt_value === "today" && selectedFilter && selectedFilter.value === 0 && (
                <div className="col-lg-3 mb-2">
                    <label className="text-black font-w500 fs-7">Today</label>
                    <div className='datepicker-wrapper d-flex'>
                    <div className='input-group-text bg-transparent border-0 px-0'>
                        <i className='fa-solid fa-calendar-days fs-4'></i>
                    </div>
                    <DatePicker
                        value={today_fil_value}
                        onChange={setTodayFilValue}
                        format="DD-MM-YYYY"
                        readOnly={true}
                    />
                    </div>
                </div>
                )}

                {date_fil_selt_value === "week" && selectedFilter && selectedFilter.value === 0 && (
                <>
                    <div className="col-lg-3 mb-2">
                    <label className="text-black font-w500 fs-7">Start Date</label>
                    <div className='datepicker-wrapper d-flex'>
                        <div className='input-group-text bg-transparent border-0 px-0'>
                        <i className='fa-solid fa-calendar-days fs-4'></i>
                        </div>
                        <DatePicker
                        value={week_stdt_fil_value}
                        onChange={setWeekSTDTFilValue}
                        format="DD-MM-YYYY"
                        />
                    </div>
                    </div>
                    <div className="col-lg-3 mb-2">
                    <label className="text-black font-w500 fs-7">End Date</label>
                    <div className='datepicker-wrapper d-flex'>
                        <div className='input-group-text bg-transparent border-0 px-0'>
                        <i className='fa-solid fa-calendar-days fs-4'></i>
                        </div>
                        <DatePicker
                        value={week_eddt_fil_value}
                        onChange={setWeekEDDTFilValue}
                        format="DD-MM-YYYY"
                        calendarPosition="top-end"
                        />
                    </div>
                    </div>
                </>
                )}

                {date_fil_selt_value === "month" && selectedFilter && selectedFilter.value === 0 && (
                <div className="col-lg-3 mb-2">
                    <label className="text-black font-w500 fs-7">This Month</label>
                    <div className='datepicker-wrapper d-flex'>
                    <div className='input-group-text bg-transparent border-0 px-0'>
                        <i className='fa-solid fa-calendar-days fs-4'></i>
                    </div>
                    <DatePicker
                        value={month_fil_value}
                        onChange={setMonthFilValue}
                        format="MMM-YYYY"
                        calendarPosition="top"
                        mode="single"
                        onlyMonthPicker={true}
                    />
                    </div>
                </div>
                )}

                {date_fil_selt_value === "custom" && selectedFilter && selectedFilter.value === 0 && (
                <>
                    <div className="col-lg-3 mb-2">
                    <label className="text-black font-w500 fs-7">Start Date</label>
                    <div className='datepicker-wrapper d-flex'>
                        <div className='input-group-text bg-transparent border-0 px-0'>
                        <i className='fa-solid fa-calendar-days fs-4'></i>
                        </div>
                        <DatePicker
                        value={custom_stdt_fil_value}
                        onChange={setCustomSTDTFilValue}
                        format="DD-MM-YYYY"
                        />
                    </div>
                    </div>
                    <div className="col-lg-3 mb-2">
                    <label className="text-black font-w500 fs-7">End Date</label>
                    <div className='datepicker-wrapper d-flex'>
                        <div className='input-group-text bg-transparent border-0 px-0'>
                        <i className='fa-solid fa-calendar-days fs-4'></i>
                        </div>
                        <DatePicker
                        value={custom_eddt_fil_value}
                        onChange={setCustomEDDTFilValue}
                        format="DD-MM-YYYY"
                        calendarPosition="top-end"
                        />
                    </div>
                    </div>
                </>
                )}
 
            </div> 
            {selectedVendor && selectedFilter?.value === 1 && selectedVendorInfo && (
                <div>
                    {vendorPurchases.length > 0 ? (
                        <>
                        <div className='text-center mb-3'>

    {/* Heading */}
    <h3 className='text-danger font-w600 mb-2'>Vendor Details</h3>

    {/* Vendor Name + Score */}
    {/* <span className='text-primary fs-5 font-w500'>Vendor - </span> */}

    <Badge
        bg="none"
        className='border border-green px-2 py-0 text-primary fs-5'
    >
        {selectedVendorInfo.vendor_businessname}
    </Badge>

    <label
        className="text-black font-w600 fs-7 px-2 py-1 rounded ms-2"
        style={{
            backgroundColor:
                selectedVendorInfo.vendor_score === 100 ? '#d4edda' : '#f8d7da',
            color:
                selectedVendorInfo.vendor_score === 100 ? '#155724' : '#721c24',
            border:
                selectedVendorInfo.vendor_score === 100
                    ? '1px solid #28a745'
                    : '1px solid #dc3545',
            display: 'inline-block',
            minWidth: '60px',
            textAlign: 'center',
            fontWeight: '600',
        }}
    >
        {selectedVendorInfo.vendor_score == null
            ? '000'
            : selectedVendorInfo.vendor_score === 100
            ? selectedVendorInfo.vendor_score
            : `-${selectedVendorInfo.vendor_score}`}
    </label>

                        </div>

                        
                        <div className="table-container">
                            <table className="product_data_table table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                <thead>
                                    <tr className=" text-start text-muted fw-bold fs-6 gs-0 th_head">
                                        <th className='text-start'>Date</th>
                                        <th >Purchase ID</th>
                                        <th className='text-center'>Raw Material Count</th>
                                        <th className='text-end'>Estimate/Actual Amount</th>
                                        <th className='text-end'>Amount</th>
                                        <th className='text-end'>Actions</th>
                                    </tr>
                                </thead>
                                <tbody className="text-gray-600 fw-semibold fs-7">
                                    {vendorPurchases.map((purchase) => (
                                        <tr>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>{formatDate(purchase.purchase_date)}</label> 
                                            </td>
                                            <td>
                                                <label className='text-black font-w400 fs-7'>{purchase.purchase_id}</label>

                                            </td>
                                            <td className='text-center'>
                                                <Badge bg="success" className='text-white fs-7 py-0 px-1'>
                                                    <span>{purchase.no_of_rawmaterial}</span>
                                                </Badge>
                                            </td>
                                            <td align='right'>
                                                <Badge bg="none" className='border border-success text-success fs-7 py-0 px-1'>
                                                    <span><i class="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                                    <span>{purchase.estimate_amount}</span>
                                                </Badge>
                                                 {purchase.actual_amount ? (
                                                <Badge bg="none" className='text-danger border border-danger fs-7 py-0 px-1'>
                                                    <span><i class="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                                    <span>{purchase.actual_amount}</span>
                                                </Badge>
                                                ):(
                                                    <span className='text-black'>-</span>
                                                )}
                                            </td>
                                            <td align='right'>
                                                {purchase.actual_amount ? (
                                                <Badge bg="none" className='text-danger border border-danger fs-7 py-0 px-1'>
                                                    <span><i class="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                                    <span>{purchase.actual_amount}</span>
                                                </Badge>
                                                ):(
                                                    <span className='text-black'>-</span>
                                                )}
                                            </td>
                                            <td className='text-end'>
                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>View</span></Tooltip>} >
                                                    <Link>
                                                        <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => handleModalToggle_View(purchase)}>
                                                            <span><i class="fa fa-eye fs-6 mt-1"></i></span>
                                                        </Button>
                                                    </Link>
                                                </OverlayTrigger>
                                            </td>
                                        </tr> 
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        </>
                    ):(
                        <span className='text-black text-center'>No Data Availabel</span>
                    )}
                </div>
            )}
    
            {selectedFilter?.value === 2 && selectedRawMaterial && (
                <div>
                    {rawMaterialPurchases.length > 0 ? (
                        <>
                            <div className="text-center fs-5 font-w500 text-danger mb-3">
                                <span className="text-primary">Raw Material</span>
                                <span className="text-primary"> - </span>
                                <Badge
                                    bg="none"
                                    className="border border-green px-2 py-0 text-primary fs-5"
                                >
                                    {selectedRawMaterial.label}
                                </Badge>
                            </div>

                            <div className="table-container">
                                <table className="product_data_table table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                <thead>
                                    <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                    <th className="min-w-100px text-start">Date</th>
                                    <th className="min-w-100px">Purchase ID</th>
                                    <th className="min-w-50px">Vendor</th>
                                    <th className="min-w-50px">Brand</th>
                                    <th className="min-w-50px text-center">Quantity/Unit</th>
                                    <th className="min-w-50px text-end">Estimate/Total Amount</th>
                                    {/* <th className="min-w-50px text-end">Amount</th> */}
                                    </tr>
                                </thead>
                                <tbody className="text-gray-600 fw-semibold fs-7">
                                    {rawMaterialPurchases.map((purchase) =>
                                    purchase.raw_material
                                        .filter(
                                        (rm) => rm.raw_material_id === selectedRawMaterial.value
                                        )
                                        .map((rm, idx) => (
                                        <tr key={`${purchase.sno}-${rm.id}`}>
                                            <td>
                                            <label className="text-black font-w400 fs-7">
                                                {new Date(purchase.purchase_date || "-").toLocaleDateString(
                                                "en-GB",
                                                { day: "2-digit", month: "short", year: "numeric" }
                                                )}
                                            </label>
                                            </td>
                                            <td>
                                            <label className="text-black font-w400 fs-7">
                                                {purchase.purchase_id || "-"}
                                            </label>
                                            </td>
                                          <td>
                                            <label className="text-black font-w400 fs-7">
                                                {purchase.vendor_businessname || "-"}
                                            </label>

                                            <label
                                                className="ms-2 px-2 py-0 rounded fs-7"
                                                style={{
                                                    backgroundColor:
                                                        purchase.vendor_score === 100 ? "#d4edda" : "#f8d7da",
                                                    color:
                                                        purchase.vendor_score === 100 ? "#155724" : "#721c24",
                                                    border:
                                                        purchase.vendor_score === 100
                                                            ? "1px solid #28a745"
                                                            : "1px solid #dc3545",
                                                    fontWeight: "600",
                                                    display: "inline-block",
                                                    minWidth: "45px",
                                                    textAlign: "center",
                                                }}
                                            >
                                                {purchase.vendor_score == null
                                                    ? "000"
                                                    : purchase.vendor_score === 100
                                                    ? purchase.vendor_score
                                                    : `-${purchase.vendor_score}`}
                                            </label>
                                        </td>

                                            <td>
                                            <label className="text-black font-w400 fs-7">
                                                {rm.brand || "-"}
                                            </label>
                                            </td>
                                            <td className="text-center">
                                            <label className="text-danger fs-7 font-w500 py-0 px-1">
                                                {rm.quantity || "-"} {rm.unitslug_name || "-"}
                                            </label>
                                            </td>
                                            <td align="right">
                                                {rm.estimate_amount ? (
                                                <Badge
                                                    bg="none"
                                                    className="text-success border border-success fs-7 py-0 px-1"
                                                >
                                                    <span>
                                                    <i className="fa-solid fa-indian-rupee-sign me-2"></i>
                                                    </span>
                                                    <span>{rm.estimate_amount || "-"}  </span>
                                                </Badge>
                                            ):(
                                                    <span className='text-black'>-</span>
                                                )}

                                                {rm.actual_amount ? (
                                                <Badge
                                                    bg="none"
                                                    className="text-danger border border-danger fs-7 py-0 px-1"
                                                >
                                                    <span>
                                                        <i className="fa-solid fa-indian-rupee-sign me-2"></i>
                                                    </span>
                                                    <span>{rm.actual_amount || "-"}</span>
                                                </Badge>
                                                ):(
                                                    <span className='text-black'>-</span>
                                                )}
                                            </td>
                                            {/* <td align="right">
                                                {rm.actual_amount ? (
                                                <Badge
                                                    bg="none"
                                                    className="text-danger border border-danger fs-7 py-0 px-1"
                                                >
                                                    <span>
                                                        <i className="fa-solid fa-indian-rupee-sign me-2"></i>
                                                    </span>
                                                    <span>{rm.actual_amount || "-"}</span>
                                                </Badge>
                                                ):(
                                                    <span className='text-black'>-</span>
                                                )}
                                            </td> */}
                                        </tr>
                                        ))
                                    )}
                                </tbody>
                                </table>
                            </div>
                        </>
                    ) : (
                        <span className='text-black text-center'>No Data Available</span>
                    )}
                </div>
            )}

            {selectedFilter && selectedFilter.value === 0 && (
                <div className="table-container"> 

                    <table className="product_data_table table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                        <thead>
                            <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                            <th className="min-w-100px text-start">Date</th>
                            <th className="min-w-100px">Purchase ID</th>
                            <th className="min-w-100px text-start">Vendor/Score</th>
                            <th className="min-w-100px text-center">Raw Material Count</th>
                            <th className="min-w-100px text-end">Estimate/Actual Amount</th> 
                            <th className="min-w-100px text-end">Actions</th>
                            </tr>
                        </thead>
                        <tbody className="text-gray-600 fw-semibold fs-7">
                            {filteredPurchases.length > 0 && filteredPurchases.map((purchase) => (
                                <tr key={purchase.sno}>
                                    <td>
                                        <label className="text-black font-w400 fs-7">
                                        {new Date(purchase.purchase_date).toLocaleDateString("en-GB", {
                                            day: "2-digit",
                                            month: "short",
                                            year: "numeric",
                                        })}
                                        </label>
                                    </td>
                                    <td>
                                        <label className="text-black font-w400 fs-7">{purchase.purchase_id}</label>
                                    </td> 
                                    <td className='text-start'>
                                        {/* Vendor Name + Score */}
                                        <div>
                                            <span className="text-black font-w400 fs-7">
                                                {purchase.vendor_businessname}
                                            </span>

                                            <span
                                                className="text-black font-w600 fs-7 px-2 py-1 rounded ms-2"
                                                style={{
                                                    backgroundColor:
                                                        purchase.vendor_score === 100 ? "#d4edda" : "#f8d7da",
                                                    color:
                                                        purchase.vendor_score === 100 ? "#155724" : "#721c24",
                                                    border:
                                                        purchase.vendor_score === 100 ? "1px solid #28a745" : "1px solid #dc3545",
                                                    display: "inline-block",
                                                    minWidth: "60px",
                                                    textAlign: "center",
                                                    fontWeight: "600",
                                                }}
                                            >
                                                {purchase.vendor_score == null
                                                    ? "000"
                                                    : purchase.vendor_score === 100
                                                    ? purchase.vendor_score
                                                    : `-${purchase.vendor_score}`}
                                            </span>
                                        </div>


                                    </td>
                                    <td className='text-center'>
                                                                                {/* Raw Material Count */}
                                        <div className="mt-1">
                                            <Badge bg="info" className="text-white fs-7 py-0 px-1">
                                                {purchase.no_of_rawmaterial}
                                            </Badge>
                                        </div>
                                    </td> 
                                    <td align="right">
                                        <Badge bg="none" className="text-success border border-success fs-7 py-0 px-1">
                                        <span>
                                            <i className="fa-solid fa-indian-rupee-sign me-2"></i> 
                                        </span>
                                        <span>{purchase.estimate_amount} </span>
                                        </Badge> / 
                                        {purchase.actual_amount ? (
                                        <Badge bg="none" className="text-danger border border-danger fs-7 py-0 px-1">
                                        <span>
                                            <i className="fa-solid fa-indian-rupee-sign me-2"></i>
                                        </span>
                                        <span>{purchase.actual_amount}</span>
                                        </Badge>
                                        ) : (
                                            <span className='text-black'>-</span>
                                        )}
                                    </td> 
                                    <td className="text-end">
                                        <OverlayTrigger
                                        trigger={['hover', 'focus']}
                                        placement="bottom"
                                        overlay={
                                            <Tooltip className="toltip-popover">
                                            <span className="fs-8 text-white fw-semibold">View</span>
                                            </Tooltip>
                                        }
                                        >
                                        <Link>
                                            <Button
                                            variant="primary tp-btn-light px-2 py-1 me-1"
                                            onClick={() => handleModalToggle_View(purchase)}
                                            >
                                            <span>
                                                <i className="fa fa-eye fs-6 mt-1"></i>
                                            </span>
                                            </Button>
                                        </Link>
                                        </OverlayTrigger>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
 
                </div>
            )}


        </>
    )


}
export default Purchase;